import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

@NgModule({
  declarations: [],
  imports: [CommonModule],
})
export class AdminUserModule {
  adminID: string;
  adminName: string;
  adminLastName: string;
  adminEmail: string;
  adminImgProfile: string;
  adminType: number;
  adminStatus: number;
  adminImgProfileFile?: File;
  adminSysRole: number;
  adminPassword?: string;
  adminCreated: Date;
}
